import { Card, TogglerCheckbox } from '@factorialco/deprecated-design-system'
import { FormikErrors } from 'formik'

import DayPicker from 'modules/core/components/DayPicker'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { DateValues, LearningPlatformData } from '../NewTrainingWizard/types'

type Props = {
  data: LearningPlatformData
  setCurrentData: (value: LearningPlatformData) => void
  open: boolean
  setOpen: (value: boolean) => void
  errors: FormikErrors<LearningPlatformData>
  disabled?: boolean
  onSubmitLP?: () => void
}

export const LearningPlatformComponent = ({
  data,
  open,
  setOpen,
  setCurrentData,
  errors,
  disabled = false,
}: Props) => {
  const onChangeDates = (values: DateValues) => {
    const [startDate, endDate] = values
    setCurrentData({ ...data, startDate: startDate ?? '', endDate: endDate })
  }

  return (
    <Card>
      <Card.Title
        size="small"
        action={<TogglerCheckbox value={open} onChange={setOpen} disabled={disabled} />}
      >
        {i18n.t(
          'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.title'
        )}
      </Card.Title>
      <Card.Description>
        {i18n.t(
          'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.description'
        )}
      </Card.Description>
      {data && (
        <Card.ExpandableContent expanded={open}>
          <TextField
            label={i18n.t(
              'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.name_label'
            )}
            value={data?.name ?? ''}
            mandatory
            onChange={(value) => {
              setCurrentData({ ...data, name: value })
            }}
            error={errors.name}
          />
          <TextField
            label={i18n.t(
              'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.link_label'
            )}
            value={data?.link ?? ''}
            mandatory
            placeholder={i18n.t('trainings.common.https_placeholder')}
            onChange={(value) => {
              setCurrentData({ ...data, link: value })
            }}
            error={errors.link}
          />
          <DayPicker
            value={[data.startDate || '', data.endDate || '']}
            label={i18n.t(
              'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.availability_label'
            )}
            mode="range"
            onChange={(value) => {
              onChangeDates(value)
            }}
          />

          <TextField
            type="number"
            label={i18n.t(
              'trainings.trainings_revamp.new_training.wizard.basic_information.learning_platform.duration_label'
            )}
            step={'1'}
            min={0}
            value={data?.duration}
            onChange={(value) => {
              setCurrentData({ ...data, duration: value })
            }}
          />
        </Card.ExpandableContent>
      )}
    </Card>
  )
}
